import { CheckIconGreen } from 'assets/icons';
import cn from 'classnames';
import { PromotionInfoLabelProps } from 'shared/components/PromotionInfoLabel';

export const PromotionInfoLabel = ({ text, className }: PromotionInfoLabelProps) => {
	return (
		<div
			className={cn(
				'border-success-500 bg-success-300 text-success-700 border w-full rounded-8 py-2 pl-2 flex gap-4 items-center text-paragraph-md lg:text-paragraph-lg',
				{ className },
			)}
		>
			<CheckIconGreen className="flex-shrink-0" />
			{text}
		</div>
	);
};
